var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pet-review-back{background-image:url(" + escape(require("../../assets/img/backgrounds/background-after-login.jpg")) + ");background-repeat:no-repeat;max-width:inherit;max-height:100%;background-position:50%;background-size:cover;min-height:100vh}", ""]);

// exports
